import { IPersonBadge } from "../../../types";
import PublicApiService from "../../../../services/PublicApiService";
import { FetchEventBadgesResponse } from "../../../../redux/types";
import utils from "../../../hocs/utils/utils";
import { BadgePaymentStatus } from "../../../enums";
import { badgeSyncRequestStarted, badgeSyncRequestCompleted, badgeSyncRequestFailed } from "redux/metadata/slice/metadataSlice";
import store from "../../../../redux/store";

class BadgeHelper {
  private _badges: IPersonBadge[] = [];
  private _isInitialised = false;

  get isInitialised() {
    return this._isInitialised;
  }

  get badges(): IPersonBadge[] {
    return this._badges;
  }

  setBadgesWithoutFilter(badges: IPersonBadge[]) {
    this._badges = badges;
  }

  set badges(badges: IPersonBadge[]) {
    let currentBadges = this._badges;

    badges.forEach(badge => {
      const cachedBadge = currentBadges.find(cached => cached.id === badge.id);
      if (cachedBadge) {
        currentBadges = currentBadges.map(b => (b.id === badge.id ? badge : b));
        return;
      }
      currentBadges.push(badge);
    });

    this._badges = currentBadges.filter(badge => utils.isBadgeValid(badge) && badge.id);
  }

  async fetchEventBadges(gbsCode: string) {
    store.dispatch(badgeSyncRequestStarted());
    try {
      const response = await PublicApiService.getOdinBadges(gbsCode);
      this._badges = [...response.results];
      await this.handlePagination(response, gbsCode);
      store.dispatch(badgeSyncRequestCompleted());
    } catch (e) {
      console.error(e);
      store.dispatch(badgeSyncRequestFailed());
    }
    this._badges = this.badges.filter(badge => utils.isBadgeValid(badge) && badge.id);
    this._isInitialised = true;
    return this.badges;
  }

  async handlePagination(badgesResponse: FetchEventBadgesResponse, gbsCode: string) {
    if (!badgesResponse.token) {
      return;
    }
    const response = await PublicApiService.getOdinBadges(gbsCode, badgesResponse.token);
    this._badges = [...this.badges, ...response.results];
    await this.handlePagination(response, gbsCode);
  }

  isBadgePaymentStatusValid(paymentStatus: IPersonBadge["paymentStatus"]) {
    return Boolean(paymentStatus && Object.values(BadgePaymentStatus).includes(paymentStatus));
  }
}

export default new BadgeHelper();
